// Zentrale Unternehmensdaten. Alle Komponenten (Footer, Kontakt, Impressum,
// Datenschutz, strukturierte Daten) greifen auf diese Datei zu, damit
// Änderungen nur an einer Stelle nötig sind.
const address = 'Bahnhofstraße 19, 53783 Eitorf';

const company = {
  legalName: 'Cura Care GmbH',
  brandName: 'Cura Care',
  tagline: 'Ambulanter Pflegedienst in Eitorf',
  street: 'Bahnhofstraße 19',
  zip: '53783',
  city: 'Eitorf',
  region: 'Nordrhein-Westfalen',
  country: 'DE',
  address,
  phone: '02243 8455323',
  phoneIntl: '+4922438455323',
  email: 'info@curacare-pflegedienst.de',
  privacyEmail: 'datenschutz@curacare-pflegedienst.de',
  url: 'https://curacare-pflegedienst.de',
  instagram: 'https://www.instagram.com/curacare_pflegedienst/',
  /* Vertretungsberechtigte Person laut Team-Seite (Geschäftsführung & PDL). */
  managingDirector: 'Ayfer Evmez',
  dataProtectionOfficer: 'Max Pelz',
  /* TODO: Handelsregister-Angaben eintragen (Pflichtangaben für eine GmbH),
     z. B. court: 'Amtsgericht Siegburg', number: 'HRB 12345'. Solange die
     Felder leer sind, werden die Zeilen im Impressum nicht angezeigt. */
  register: {court: '', number: ''},
  /* TODO: Umsatzsteuer-Identifikationsnummer eintragen, falls vorhanden. */
  vatId: '',
  /* Zuständige Aufsichtsbehörde nach dem Wohn- und Teilhabegesetz NRW (WTG),
     das auch für ambulante Pflegedienste gilt. Angabe im Impressum. */
  supervisoryAuthority: {
    name: 'Rhein-Sieg-Kreis, Kreissozialamt, Heimaufsicht (WTG-Behörde)',
    street: 'Kaiser-Wilhelm-Platz 1',
    city: '53721 Siegburg',
    url: 'https://www.rhein-sieg-kreis.de/vv/produkte/Amt_50/Abteilung_50.2/Heimaufsicht_.php'
  },
  openingHours: {
    label: 'Montag bis Freitag, 08:00 bis 16:30 Uhr',
    days: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
    opens: '08:00',
    closes: '16:30'
  },
  /* Einzugsgebiet laut Website: "Eitorf und Umgebung".
     TODO: weitere Orte ergänzen, sobald das Versorgungsgebiet feststeht. */
  serviceArea: ['Eitorf'],
  mapsUrl: `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`Cura Care GmbH, ${address}`)}`,
  mapsEmbedUrl: `https://www.google.com/maps?q=${encodeURIComponent(address)}&output=embed`
};

export default company;
